import { Divider, Button, Input, Modal } from 'antd';
import React, { Suspense } from 'react';
import { useNavigate } from 'react-router-dom';

import MyInput from '../components/Input';
import MyButton from '../components/Button';
import Typography from '../components/Typography';
import { COLORS } from '../constants/Colors';
import useIsDesktop from '../utils/hooks/useIsDesktop';
import { FormattedMessage } from 'react-intl';

const CookiePolicyModal = (props) => {
  const { isOpen, onCancle } = props;
  // const navigate = useNavigate();

  const isDesktop = useIsDesktop();

  return (
    <Modal
      title={
        <Typography
          color={COLORS.Primary}
          isBold
          size={isDesktop ? '40px' : '18px'}
          lineHeight={isDesktop ? '60px' : '14px'}
          className='pb-3 text-center'
        >
          <FormattedMessage id='labelCookiePolicy' defaultMessage='Cookies Policy' />
        </Typography>
      }
      open={isOpen}
      onOk={() => {}}
      onCancel={onCancle}
      width={680}
      footer={
        [
          // <MyButton className="w-25" onClick={onCancle}>
          //   Cancel
          // </MyButton>,
          // <MyButton isPrimary onClick={onCancle} className="w-25">
          //   Accept
          // </MyButton>,
        ]
      }
    >
      <Divider className='m-0' />

      <div className='d-flex flex-column px-4'>
        <Typography lineHeight='18px' className='pt-3 text-center'>
          <FormattedMessage
            id='textCookiePolicy'
            defaultMessage='Operated by Agrigate Company Limited (individually and collectively,
          “we”, “our”, “us”, or “the Company”), this website uses cookies and
          other comparable technologies to distinguish a user’s website usage
          format in order to give each user a good experience from using our
          services and to improve the quality of our services to better meet
          each user’s needs.'
          />
        </Typography>
        <Typography lineHeight='18px' className='pt-5' isBold color={COLORS.Dark}>
          <FormattedMessage id='titleAdditional' defaultMessage='Additional Information on Cookies' />
        </Typography>
        <Typography lineHeight='18px' className='pt-3' isBold color={COLORS.Dark}>
          <FormattedMessage id='titleWhatAreCookies' defaultMessage='What Are Cookies?' />
        </Typography>
        <Typography lineHeight='18px' className='pt-4'>
          <FormattedMessage
            id='textWhatAreCookies'
            defaultMessage="Cookies are text files that are stored on a user's computer and/or
          communication devices that you use, such as tablets and smartphones,
          via a web browser while you enter the Company's website. Cookies will
          not cause harm to your computer equipment and/or communication
          devices. They are used to store detailed log data, internet usage, or
          your website visit behavior. You can learn more about cookies from
          https://www.allaboutcookies.org "
          />
        </Typography>

        <Typography lineHeight='18px' className='pt-5' isBold color={COLORS.Dark}>
          <FormattedMessage id='titleBenefitsofCookies' defaultMessage='Benefits of Cookies' />
        </Typography>
        <Typography lineHeight='18px' className='pt-4'>
          <FormattedMessage
            id='textBenefitsofCookies'
            defaultMessage='A cookie informs us of the website section that you have visited. It
          collects information on your website browsing history and offers an
          uninterrupted website experience that responds to your need. Moreover,
          using cookies to record the initial settings of the website allows you
          to access the website with such settings every time, except when the
          cookies have been deleted. In which case, all of the settings will be
          restored to the default settings.'
          />
        </Typography>

        <Typography lineHeight='18px' className='pt-5' isBold color={COLORS.Dark}>
          <FormattedMessage id='titleUsageofCookies' defaultMessage='Usage of Cookies' />{' '}
        </Typography>
        <Typography lineHeight='18px' className='pt-4'>
          <FormattedMessage
            id='textUsageofCookies'
            defaultMessage='Agrigate Company Limited utilizes cookies on our websites. Through
          any browsers you use to access our services on the website, the
          cookies will be downloaded onto your computers or mobile computers to
          collect website usage formats and history, the information or the
          services of your interest, the reference number of your latest access,
          etc. The collected data will be analyzed in order to develop our
          services and to display content, advertisements, and public relations
          of appropriate activities as well as the services according to your
          interest. However, it will not be linked to any identification in any
          way. The Company will use the cookies according to the terms and
          conditions stated under our Privacy Policy.'
          />
        </Typography>

        <Typography lineHeight='18px' className='pt-5' isBold color={COLORS.Dark}>
          <FormattedMessage id='titleTypesofCookie' defaultMessage='Types of Cookie' />{' '}
        </Typography>
        <Typography lineHeight='18px' className='pt-4'>
          <FormattedMessage id='textTypesofCookie' defaultMessage='Agrigate Company Limited uses the following types of cookies:' />{' '}
        </Typography>

        <Typography lineHeight='18px' className='pt-5' isBold color={COLORS.Dark}>
          <FormattedMessage id='titleStrictlyNecessary' defaultMessage='Strictly Necessary Cookies' />{' '}
        </Typography>
        <Typography lineHeight='18px' className='pt-4'>
          <FormattedMessage
            id='textStrictlyNecessary'
            defaultMessage='These cookies enable you to access the information and use the website
          securely. They will be stored and deleted after you finish using the
          website'
          />{' '}
        </Typography>

        <Typography lineHeight='18px' className='pt-5' isBold color={COLORS.Dark}>
          <FormattedMessage id='titleAnalytical' defaultMessage='Analytical/Performance Cookies' />{' '}
        </Typography>
        <Typography lineHeight='18px' className='pt-4'>
          <FormattedMessage
            id='textAnalytical'
            defaultMessage='These cookies permit us to analyze or measure the performance of the
          website. They collect statistical data on the way the website is
          accessed and on the user behavior while visiting the website by, for
          example, recording and counting the number of website visits in order
          for us to learn about your interest and behavior. The data will be
          used for improving the website performance and for granting easier
          searches to each user.'
          />{' '}
        </Typography>

        <Typography lineHeight='18px' className='pt-5' isBold color={COLORS.Dark}>
          <FormattedMessage id='titleFunctionalityCookies' defaultMessage='Functionality Cookies' />{' '}
        </Typography>
        <Typography lineHeight='18px' className='pt-4'>
          <FormattedMessage
            id='textFunctionalityCookies'
            defaultMessage='These cookies allow us to recognize you and provide you with more
          convenience next time you return to our website by recording the
          choices you make during your current access and website settings
          including remembering your user name and adjusting the font size, the
          language, and other features on the website as per your preferences.
          However, as the data to be processed is anonymized, it does not
          contain any information that identifies you or store any personal
          information.'
          />{' '}
        </Typography>

        <Typography lineHeight='18px' className='pt-5' isBold color={COLORS.Dark}>
          <FormattedMessage id='titleTargetingCookies' defaultMessage='Targeting Cookies' />{' '}
        </Typography>
        <Typography lineHeight='18px' className='pt-4'>
          <FormattedMessage
            id='textTargetingCookies'
            defaultMessage='These cookies record how you use the website, which pages you visit,
          and which links you click on. The collected data will be used for
          adjusting the website and the content displayed on the pages to better
          respond to your interest.'
          />{' '}
        </Typography>

        <Typography lineHeight='18px' className='pt-5' isBold color={COLORS.Dark}>
          <FormattedMessage id='titleAdvertisingCookies' defaultMessage='Advertising Cookies' />{' '}
        </Typography>
        <Typography lineHeight='18px' className='pt-4'>
          <FormattedMessage
            id='textAdvertisingCookies'
            defaultMessage='These cookies are saved on your devices in order to collect data on
          your website access and the links you click on, allowing us to learn
          about your needs. The collected data will be used for improving the
          website and for presenting the most relevant advertisements according
          to your interest.'
          />{' '}
        </Typography>

        <Typography lineHeight='18px' className='pt-5' isBold color={COLORS.Dark}>
          <FormattedMessage id='titleHowtoManage' defaultMessage='How to Manage Cookie Settings and Disabling' />{' '}
        </Typography>
        <Typography lineHeight='18px' className='pt-4'>
          <FormattedMessage
            id='textHowtoManage'
            defaultMessage='Cookies may be disabled through your web browser and privacy settings
          in order to restrain the cookies from collecting information in the
          future (please see AboutCookies.org for more information). However,
          because certain services on our website require the utilization of
          cookies, disabling them may interrupt some or all of the functions of
          these services.'
          />{' '}
        </Typography>
      </div>
    </Modal>
  );
};

export default CookiePolicyModal;
